var _g, _rect, _path, _rect2, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg83NotCovered(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_84661",
    "data-name": "Group 84661",
    xmlns: "http://www.w3.org/2000/svg",
    width: 80.252,
    height: 80.235,
    viewBox: "0 0 80.252 80.235",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_84660",
    "data-name": "Group 84660",
    transform: "translate(29.798 24.086)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24673",
    "data-name": "Rectangle 24673",
    width: 3.24,
    height: 2.056,
    fill: "#ffb164"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24674",
    "data-name": "Rectangle 24674",
    width: 3.24,
    height: 2.056,
    transform: "translate(17.419)",
    fill: "#ffb164"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24675",
    "data-name": "Rectangle 24675",
    width: 2.399,
    height: 2.056,
    transform: "translate(76.459 78.178)",
    fill: "#ffb164"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_240138",
    "data-name": "Path 240138",
    d: "M138.655,78.722l.014-4.659H141.6a6.2,6.2,0,0,0,6.073-7.254L144.133,47a14.032,14.032,0,0,0-14.622-11.51A13.79,13.79,0,0,0,131,30.561l2.133-.528a1.027,1.027,0,0,0,.78-1V20.977a1.026,1.026,0,0,0-1.026-1.026h-1.8V16.39h3.544V14.332h-2.058a15.451,15.451,0,0,0-30.722,0H99.791V16.39h3.544v3.561h-1.8a1.026,1.026,0,0,0-1.026,1.026v8.057a1.027,1.027,0,0,0,.78,1l2.133.528a13.789,13.789,0,0,0,1.491,4.928A14.034,14.034,0,0,0,90.287,47l-3.544,19.81a6.2,6.2,0,0,0,6.073,7.254h2.971l-.014,4.659H83.6V80.78h66.866V78.722ZM105.568,31.1l6.253,1.549a1.019,1.019,0,0,0,.946-.243l4.438-4.139,4.438,4.139a1.027,1.027,0,0,0,.949.243l6.261-1.549a11.819,11.819,0,0,1-23.285,0m-.177-14.705h23.639v3.561H105.391Zm-2.83,11.842V22.007h29.3v6.225l-9.221,2.285L117.907,26.1a1.029,1.029,0,0,0-1.4,0l-4.731,4.413Zm-4.651,24.2a2.4,2.4,0,0,1,2.4-2.393h33.97a2.412,2.412,0,0,1,2.4,2.407l-.08,26.276H97.829Z",
    transform: "translate(-77.084 -0.545)",
    fill: "#8e8e8e"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24676",
    "data-name": "Rectangle 24676",
    width: 2.399,
    height: 2.056,
    transform: "translate(1.464 78.178)",
    fill: "#ffb164"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_240139",
    "data-name": "Path 240139",
    d: "M103.131,19.375c-6.377,0-11.565,4.28-11.565,9.54a8.687,8.687,0,0,0,3.107,6.516,2.631,2.631,0,0,1,.869,1.978v2.7a2.743,2.743,0,0,0,2.742,2.742h9.7a2.745,2.745,0,0,0,2.742-2.742v-2.7a2.628,2.628,0,0,1,.866-1.978,8.687,8.687,0,0,0,3.107-6.516C114.7,23.655,109.508,19.375,103.131,19.375Zm7.1,14.514a4.687,4.687,0,0,0-1.563,3.519v2.7a.685.685,0,0,1-.683.686h-1.176V39.141h-2.056V40.8h-3.237V39.141H99.457V40.8H98.284a.686.686,0,0,1-.686-.686v-2.7a4.683,4.683,0,0,0-1.563-3.519,6.663,6.663,0,0,1-2.413-4.975c0-4.125,4.266-7.484,9.509-7.484s9.509,3.359,9.509,7.484a6.663,6.663,0,0,1-2.413,4.975",
    transform: "translate(-63.005 32.723)",
    fill: "#ffb164"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_240140",
    "data-name": "Path 240140",
    d: "M95.061,22.826A1.371,1.371,0,1,1,93.689,24.2a1.372,1.372,0,0,1,1.372-1.372",
    transform: "translate(-59.254 38.819)",
    fill: "#ffb164"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_240141",
    "data-name": "Path 240141",
    d: "M98.183,22.826A1.371,1.371,0,1,1,96.811,24.2a1.372,1.372,0,0,1,1.372-1.372",
    transform: "translate(-53.738 38.819)",
    fill: "#ffb164"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_240142",
    "data-name": "Path 240142",
    d: "M96.309,28.015l-1.527-1.378,1.942-2.155a1.032,1.032,0,0,1,1.541.017l1.868,2.155L98.578,28l-1.1-1.275Z",
    transform: "translate(-57.323 41.15)",
    fill: "#ffb164"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_240143",
    "data-name": "Path 240143",
    d: "M120.479,11.921a4.117,4.117,0,0,0-3.085-3.981V1.654h-2.056V7.937a4.113,4.113,0,0,0,0,7.965V20.52a4.412,4.412,0,0,1-8.823,0V17.043l1.666,2.1,1.61-1.278-3.5-4.41a1.035,1.035,0,0,0-1.834.639v6.43a6.467,6.467,0,0,0,12.934,0V15.9a4.117,4.117,0,0,0,3.085-3.981",
    transform: "translate(-40.227 1.414)",
    fill: "#ffb164"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_240144",
    "data-name": "Path 240144",
    d: "M97.207,1.282H83.985a2.745,2.745,0,0,0-2.742,2.742V11.35a2.747,2.747,0,0,0,2.742,2.742H93.24L98.33,17.68c.9.653,1.643.13,1.621-.838V4.024a2.745,2.745,0,0,0-2.745-2.742m-3.45,6.411a1.112,1.112,0,1,1,1.109,1.115,1.112,1.112,0,0,1-1.109-1.115m-2.058,0a1.115,1.115,0,1,1-1.115-1.115A1.117,1.117,0,0,1,91.7,7.693m-4.283,0A1.114,1.114,0,1,1,86.3,6.578a1.116,1.116,0,0,1,1.118,1.115",
    transform: "translate(-81.243 0.757)",
    fill: "#ffb164"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg83NotCovered);
export default __webpack_public_path__ + "static/media/8.3_Not_Covered.111d2bd3dd8c08d449a12652ebaa09c3.svg";
export { ForwardRef as ReactComponent };